import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Dispersion } from 'src/app/shared/models/dispersions';
import { DispersionsService } from 'src/app/shared/services/dispersions.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-dispersions',
  templateUrl: './dispersions.component.html',
  styleUrls: ['./dispersions.component.scss']
})
export class DispersionsComponent implements OnInit {
  _subscriptions: Subscription[] = [];
  dispersions: Dispersion[];
  dispersionsCompleted: Dispersion[];
  dispersionsPending: Dispersion[];
  cdta: any;

  constructor(
    private router: Router,
    private dispesrionsService: DispersionsService,
    private utilitiesService: UtilitiesService,
  ) {
    this.cdta = this.utilitiesService.getCompanyData();
    console.log(this.cdta);
    this._subscriptions.push(
      this.dispesrionsService.getCompanyDispersions(this.cdta.id).subscribe(dispersions => {
        this.dispersions = dispersions;
        this.dispersionsCompleted = _.filter(dispersions, ['status', 3]);
        this.dispersionsPending = dispersions.filter(dispersion => dispersion.status <= 2);
      })
    );
  }

  ngOnInit() {
  }

  newDispersion() {
    this.router.navigate(['/dash/dispersions/new/']);
  }
  viewDetail(id) {
    this.router.navigate(['/dash/dispersions/' + id]);
  }
  
  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }
}
